import { Factory } from './Factory'
import Menu from '../EditorComponents/ProgressBar/Menu'

export class ProgressBarFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('progress-bar'),
      containerId: this.id('container-progress-bar'),
      textId: this.id('text-progress-bar'),
      slug: 'editor-progress-bar',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      contentClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      name: 'ProgressBar',
    }
  }

  properties() {
    return {
      content: [
        {key: 'has-title', component: 'ContentToggle', text:'has a Title', property:'hasTitle'},
      ],
      styles: [
        {key: 'progress-width', component: 'CustomWidthProgressBar'},
        {key: 'background-color', component: 'BackgroundProperty', only: ['color']},
      ],
      containerStyles: [
        {key: 'rounded', component: 'RoundedProperty', class: 'containerClasses', styles: 'containerStyles'},
        {key: 'border-color', component: 'BorderProperty', class: 'containerClasses', styles: 'containerStyles'},
        {key: 'background-color', component: 'BackgroundProperty', only: ['color'],class: 'containerClasses', styles: 'containerStyles'},
        {key: 'progressbar-height', component: 'ContentHeight', styles: 'containerStyles'}
      ],
      textStyles: [
        {key: 'text-color', component: 'TextColorProperty', styles: 'textStyles'},
        {key: 'border-color', component: 'BorderProperty', class: 'textClasses', styles: 'textStyles'},
        {key: 'background-color', component: 'BackgroundProperty', only: ['color'], styles: 'textStyles'}
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'}
      ],
      menu: Menu
    }
  }
}
